var _react_refresh_temp_1;
_react_refresh_temp_1 = $RefreshSig$();
// '#context' is imported by direct path: its barrel would close the context <-> query-hooks cycle (see CLAUDE.md).
import { useQuery } from '@tanstack/react-query';
import { RefetchIntervals } from '#constants';
import { useLucidSdk } from '#context/LucidSdk';
import { CurrentProfileKeyFactory } from '../../query-key-factories';
export const useCurrentProfile = ({ enabled = false, }) => {
    _react_refresh_temp_1();
    const { lucidSdk } = useLucidSdk();
    const query = useQuery({
        queryFn: () => {
            try {
                return lucidSdk.currentUserManagement().getProfile();
            }
            catch (error) {
                return null;
            }
        },
        queryKey: CurrentProfileKeyFactory.exact(),
        refetchInterval: (data) => {
            if (!data.state.data) {
                return false;
            }
            if (!data.state.data?.emailVerified) {
                return RefetchIntervals.xs;
            }
            if (data.state.data?.pendingInvitation) {
                return RefetchIntervals.xs;
            }
            return false;
        },
        enabled,
        networkMode: 'always',
        retry: false,
    });
    return {
        query,
    };
};
_react_refresh_temp_1(useCurrentProfile, "H/nX1eMsJ0bsH20/D0j9QAs2SDk=", false, () => [useLucidSdk, useQuery]);
